import { render, staticRenderFns } from "./AssemblyForm.vue?vue&type=template&id=0aa67771&"
import script from "./AssemblyForm.vue?vue&type=script&lang=js&"
export * from "./AssemblyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports